function checkKeystore(event) {
    if (event.key === ' ' && event.ctrlKey) {
        event.preventDefault();
        event.stopPropagation();
        this.instance.$root.variableFinder.show(this.instance.node, event.target);
    }
}

export const VariableFinderTrigger = {
    beforeMount(el, binding) {
        el.addEventListener('keydown', checkKeystore.bind(binding), false);
    }
}
